import McPageHelpers from '../../McPageHelpers'
import { getCountryName, KEY, TYPE } from './MarketOverviewTable.settings'
import { McDataTable } from '../../../../components/Component'
import { useGlobalStoreData } from '../../../../store/globalStore'
import { useTranslation } from 'react-i18next'
import React, { forwardRef, useImperativeHandle } from 'react'
import { usePDFselectedComponentIds } from '../../../../store/pdfStore'

const MarketOverviewWorldTable = forwardRef((props, ref) => {
  const { t } = useTranslation()
  const countriesGSD = useGlobalStoreData.countries()
  const selectedComponentIds = usePDFselectedComponentIds()

  const { data, isYearTable, timeTags, type } = props

  const columns = [
    {
      name: (<div>{type === TYPE.IMPORTER ? t('importer') : t('exporter')} </div>),
      selector: row => getCountryName(row.country, countriesGSD),
      left: true,
      width: '15%'
    },
    {
      name: (
        <div>{timeTags && (isYearTable ? McPageHelpers.getColumnsName(timeTags[3], null, KEY.YEARLY) : McPageHelpers.getColumnsName(timeTags[1], null, KEY.MONTHLY, true))} ({t('thousand_dollar')})</div>),
      selector: row => McPageHelpers.numToLocaleString(Math.round(row.prev / 1000), 'decimal', false, 0, 0),
      right: true
    },
    {
      name: (
        <div>{timeTags && (isYearTable ? McPageHelpers.getColumnsName(timeTags[2], null, KEY.YEARLY) : McPageHelpers.getColumnsName(timeTags[0], null, KEY.MONTHLY, true))} ({t('thousand_dollar')})</div>),
      selector: row => McPageHelpers.numToLocaleString(Math.round(row.current / 1000), 'decimal', false, 0, 0),
      right: true
    },
    {
      name: (
        <div>{timeTags && (isYearTable ? McPageHelpers.getColumnsName(timeTags[3], timeTags[2], KEY.YEARLY, true, true) : McPageHelpers.getColumnsName(timeTags[1], timeTags[0], KEY.MONTHLY, true, true))} ({t('thousand_dollar')})</div>),
      selector: row => McPageHelpers.numToLocaleString(Math.round(row.absoluteChange / 1000)),
      right: true
    },
    {
      name: (
        <div>{timeTags && (isYearTable ? McPageHelpers.getColumnsName(timeTags[3], timeTags[2], KEY.YEARLY, true, false) : McPageHelpers.getColumnsName(timeTags[1], timeTags[0], KEY.MONTHLY, true, false))} (%)</div>),
      selector: row => McPageHelpers.numToLocaleString(row.percentChange, 'percent'),
      right: true
    }
  ]

  const worldHeadersMonthForPdf = {
    country: type === TYPE.IMPORTER ? t('importer') : t('exporter'),
    prev: timeTags && McPageHelpers.getColumnsName(timeTags[1], null, KEY.MONTHLY, true) + ' (' + t('thousand_dollar') + ')',
    current: timeTags && McPageHelpers.getColumnsName(timeTags[0], null, KEY.MONTHLY, true) + ' (' + t('thousand_dollar') + ')',
    absoluteChange: timeTags && McPageHelpers.getColumnsName(timeTags[1], timeTags[0], KEY.MONTHLY, true, true) + ' (' + t('thousand_dollar') + ')',
    percentChange: timeTags && McPageHelpers.getColumnsName(timeTags[1], timeTags[0], KEY.MONTHLY, true, false) + ' (%)'
  }

  const worldHeadersYearForPdf = {
    country: type === TYPE.IMPORTER ? t('importer') : t('exporter'),
    prev: timeTags && McPageHelpers.getColumnsName(timeTags[3], null, KEY.YEARLY) + ' (' + t('thousand_dollar') + ')',
    current: timeTags && McPageHelpers.getColumnsName(timeTags[2], null, KEY.YEARLY) + ' (' + t('thousand_dollar') + ')',
    absoluteChange: timeTags && McPageHelpers.getColumnsName(timeTags[3], timeTags[2], KEY.YEARLY, true, true) + ' (' + t('thousand_dollar') + ')',
    percentChange: timeTags && McPageHelpers.getColumnsName(timeTags[3], timeTags[2], KEY.YEARLY, true, false) + ' (%)'
  }

  useImperativeHandle(ref, () => ({
    generateTablePdf (id) {
      if (selectedComponentIds.includes(id)) {
        return [
          McPageHelpers.generatePdfTableFromObjects(McPageHelpers.getPdfTransformWorldData(data), isYearTable ? worldHeadersYearForPdf : worldHeadersMonthForPdf, true, true)
        ]
      } else return [[null, null], null]
    },
    getColumns () {
      return columns.map(column => column?.name?.props?.children)
    }
  }))

  return (
    <McDataTable data={data ?? []}
                 columns={columns}
                 id={'marketOverviewTable-' + new Date().getTime()}
                 customSort={McPageHelpers.mcDataTableCustomSort}
                 hideHeader
    />
  )
})
export default MarketOverviewWorldTable
